/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContactUsModel { 
    /**
     * email id of the user
     */
    email: string;
    /**
     * message from the user
     */
    message: string;
}

